import { createAction, props } from '@ngrx/store';
import { AppStateFailure } from '@symphony-solo/shared/common-state/src';
import { CustomerGroupDto } from '../dtos';

export enum CustomerGroupsActionTypes {
  LoadCustomerGroups = '[CustomerGroups] LoadCustomerGroups',
  LoadCustomerGroupsSuccess = '[CustomerGroups] LoadCustomerGroupsSuccess',
  LoadCustomerGroupsError = '[CustomerGroups] LoadCustomerGroupsError',
  SelectCustomerGroup = '[CustomerGroups] SelectCustomerGroup',
  ClearSelectedCustomerGroup = '[CustomerGroups] ClearSelectedCustomerGroup',
}

export const loadCustomerGroupsAction = createAction(CustomerGroupsActionTypes.LoadCustomerGroups);
export const loadCustomerGroupsSuccessAction = createAction(
  CustomerGroupsActionTypes.LoadCustomerGroupsSuccess,
  props<{ customerGroups: CustomerGroupDto[] }>()
);
export const loadCustomerGroupsErrorAction = createAction(
  CustomerGroupsActionTypes.LoadCustomerGroupsError,
  props<{ failure: AppStateFailure }>()
);
export const selectCustomerGroupAction = createAction(CustomerGroupsActionTypes.SelectCustomerGroup, props<{ customerGroupId: number }>());
export const clearSelectCustomerGroupAction = createAction(CustomerGroupsActionTypes.ClearSelectedCustomerGroup);
